<!-- Hero Section with Search -->
<section class="hero">
  <div class="container">
    <h1 class="hero__title">{{ 'hero.title' | transloco }}</h1>
    <div class="search-box">
      <div class="search-box__input">
        <app-input
          type="text"
          placeholder="{{ 'hero.jobKeywordsPlaceholder' | transloco }}"
          [hasIcon]="true"
          iconPosition="left"
          showClearButton
          class="input-large"
          [ngModel]="keyword"
          (ngModelChange)="onKeywordInput($event)"
          (keyup.enter)="onSearch()"
          (keyup.escape)="closeSuggestions()"
          (clear)="onClearKeyword()">
          <i class="fas fa-briefcase" slot="icon-left"></i>
        </app-input>

        <!-- Typeahead suggestions -->
        <div class="search-suggestions" *ngIf="showSuggestionsPanel">
          <ng-container *ngIf="hasAnySuggestions; else emptyState">
            <div class="search-suggestions__group" *ngIf="suggestionTitles.length">
              <div class="search-suggestions__label">{{ 'hero.suggestions.titlesGroup' | transloco }}</div>
              <button
                type="button"
                class="search-suggestions__item"
                *ngFor="let title of suggestionTitles"
                (click)="selectSuggestionText(title)">
                <i class="fas fa-briefcase" aria-hidden="true"></i>
                <span>{{ title }}</span>
              </button>
            </div>

            <div class="search-suggestions__group" *ngIf="suggestionCompanies.length">
              <div class="search-suggestions__label">{{ 'hero.suggestions.companiesGroup' | transloco }}</div>
              <button
                type="button"
                class="search-suggestions__item"
                *ngFor="let company of suggestionCompanies"
                (click)="selectCompany(company)">
                <i class="fas fa-building" aria-hidden="true"></i>
                <span>{{ company.name }}</span>
              </button>
            </div>
          </ng-container>

          <ng-template #emptyState>
            <div class="search-suggestions__empty">
              {{ 'hero.suggestions.empty' | transloco: { query: suggestionQuery } }}
            </div>
          </ng-template>
        </div>
      </div>
      <div class="search-box__input">
        <app-places-autocomplete
          class="d-flex h-100"
          [(ngModel)]="location"
          placeholder="{{ 'hero.locationPlaceholder' | transloco }}"
          [hasIcon]="true"
          iconPosition="left"
          [showRadiusSelector]="true"
          [radius]="searchRadius"
          (addressSelected)="onLocationSelected($event)"
          (radiusChange)="onRadiusChange($event)"
          (clear)="onClearLocation()">
          <i class="fas fa-map-marker-alt" slot="icon-left"></i>
        </app-places-autocomplete>
      </div>
      <button class="search-box__button" (click)="onSearch()">
        <i class="fas fa-search"></i>
        {{ 'button.search' | transloco }}
      </button>
    </div>
    <div class="search-box__advanced">
      <app-button size="sm" variant="outline" color="light" (click)="onOpenModal()">
        <i class="fas fa-sliders-h"></i>
        {{ 'hero.advancedSearch' | transloco }}
      </app-button>
    </div>
    <!-- Active filters will be projected here -->
    <ng-content select="[active-filters]"></ng-content>
  </div>
</section>
